"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var MCS_RUN_ENV = constants_1.ENV_NAMES.MCS_RUN_ENV;
var Matcher = /** @class */ (function () {
    function Matcher(params) {
        if (params === void 0) { params = {}; }
        var projectName = params.projectName;
        this.projectName = projectName;
    }
    Matcher.prototype.matches = function (setting, context) {
        var _this = this;
        if (context === void 0) { context = {}; }
        var filters = setting.filter;
        var url = context.url, path = context.path, email = context.email, ip = context.ip;
        if (!filters) {
            return true;
        }
        var filterKeys = Object.keys(filters);
        return filterKeys.every(function (filter) {
            var criteria = String(filters[filter]);
            switch (filter) {
                case 'application':
                    return match(_this.projectName, criteria);
                case 'environment':
                    return matchEnvironment(criteria);
                case 'server':
                    return false;
                case 'url':
                    return match(url, criteria);
                case 'host':
                    return false;
                case 'url-path':
                    return match(path, criteria);
                case 'email':
                    return match(email, criteria);
                case 'ip':
                    return match(ip, criteria);
                case 'context':
                    return matchContext(context.context, criteria);
                case 'mcs_run_env':
                    return matchEnvironment(MCS_RUN_ENV + "=" + (criteria || ''));
                case 'in_browser':
                    return true;
                default:
                    return false;
            }
        });
    };
    return Matcher;
}());
exports.Matcher = Matcher;
function matchEnvironment(condition) {
    return matchSet({
        set: process.env,
        condition: condition,
        useUppercaseNames: true,
    });
}
function matchContext(userCtx, condition) {
    return matchSet({
        set: userCtx,
        condition: condition,
        useUppercaseNames: false,
    });
}
function matchSet(params) {
    var set = params.set, condition = params.condition, useUppercaseNames = params.useUppercaseNames;
    if (typeof set !== 'object') {
        return false;
    }
    if (typeof condition !== 'string') {
        return false;
    }
    var parts = condition
        .split(',')
        .map(function (str) { return str.trim(); });
    if (!parts.length) {
        return false;
    }
    return parts.every(function (filter) {
        var _a = filter.split('='), filterName = _a[0], filterValue = _a[1];
        var setValue = set[useUppercaseNames ? filterName.toUpperCase() : filterName];
        return match(setValue, filterValue);
    });
}
function match(value, criteria) {
    if (!value || !criteria) {
        return false;
    }
    return RegExp(criteria).test(value);
}
//# sourceMappingURL=matcher.js.map